import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

function FilterSelect({
  data,
  value,
  onChange,
  placeholder,
  emptyValue,
  boolValue,
}) {
  const selectRef = useRef(null);

  useEffect(() => {
    window.jcf.replace(selectRef.current);
  }, []);

  useEffect(() => {
    window.jcf.refresh(selectRef.current);
  });

  return (
    <select
      ref={selectRef}
      value={value}
      onChange={onChange}
    >
      {placeholder && (<option className="hide">{placeholder}</option>)}
      {emptyValue && (<option value="">{emptyValue}</option>)}
      {data.map((item) => (
        <option
          key={item.key}
          value={item.key}
        >
          {boolValue && `${emptyValue}: ${(item.key ? 'Yes' : 'No')}`}
          {!boolValue && (item.key)}
          {item.doc_count && ` (${item.doc_count})`}
        </option>
      ))}
    </select>
  );
}

export { FilterSelect };

FilterSelect.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    doc_count: PropTypes.number.isRequired,
  })).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  emptyValue: PropTypes.string,
  boolValue: PropTypes.bool,
};

FilterSelect.defaultProps = {
  placeholder: '',
  emptyValue: '',
  boolValue: false,
};
